module.exports = __webpack_public_path__ + "static/aristeus-1-36400dc80cdbd4f1728c706065e2dc28.jpg";